import config from "@/config";
import type { IntakeCase } from "@/types/intake";

const MEDICARE_PAYER_NAMES = new Set(["medicare", "traditional medicare"]);

export function isMedicareBvIntakeCase(c: IntakeCase): boolean {
  if (c.case_type !== "benefits_verification") {
    return false;
  }
  const payer = (c.payer_name || "").trim().toLowerCase();
  return MEDICARE_PAYER_NAMES.has(payer);
}

export interface MedicareStructuredOutputResponse {
  case_id: string;
  success: boolean;
  status: string;
  has_stedi_eligibility_response: boolean;
  success_category: string | null;
  coverage_info_obtained: boolean | null;
  structured_outputs_source: string | null;
  medicare_structured_output_completed: boolean;
  medicare_structured_output_error: string | null;
}

export async function runMedicareStructuredOutput(
  caseId: string,
  options?: { force?: boolean },
): Promise<MedicareStructuredOutputResponse> {
  const params = new URLSearchParams();
  if (options?.force) params.set("force", "true");
  const qs = params.toString();
  const res = await fetch(
    `${config.API_BASE_URL}/api/dashboard/intake/case/${encodeURIComponent(caseId)}/medicare-structured-output${qs ? `?${qs}` : ""}`,
    { method: "POST" },
  );
  if (!res.ok) {
    let detail = `Request failed (${res.status})`;
    try {
      const data = (await res.json()) as { detail?: unknown };
      if (typeof data.detail === "string" && data.detail.trim()) {
        detail = data.detail;
      }
    } catch {
      // ignore non-JSON body
    }
    throw new Error(detail);
  }
  return (await res.json()) as MedicareStructuredOutputResponse;
}
